import React from 'react';
import type { SegmentedControlProps } from '@mantine/core';
import { SegmentedControl as BaseSegmentControl, useMantineTheme } from '@mantine/core';

export function SegmentedControl(props: SegmentedControlProps) {
  const theme = useMantineTheme();

  return <BaseSegmentControl radius={theme.spacing.xl / 3} {...props} />;
}
